import { MagicConfigMixin } from '@gig/magic-common';
import { Mixins, Prop, Component } from 'vue-property-decorator';
import { EXPERIMENT_QUERY_ACTIVE_VARIANT } from '@gig/magic-messages';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let ExperimentComponent = class extends Mixins(MagicConfigMixin) {
  constructor() {
    super(...arguments);
    this.activeExperimentVariant = false;
  }
  getActiveExperimentVariantName() {
    const activeExperiment = this.activeExperimentVariant;
    if (!activeExperiment) {
      return this.default || false;
    }
    return activeExperiment.name;
  }
  created() {
    window.queryBus.query(EXPERIMENT_QUERY_ACTIVE_VARIANT, this.name, (experiment) => {
      return this.activeExperimentVariant = experiment;
    });
  }
};
__decorateClass([
  Prop(String)
], ExperimentComponent.prototype, "name", 2);
__decorateClass([
  Prop(String)
], ExperimentComponent.prototype, "default", 2);
ExperimentComponent = __decorateClass([
  Component({
    name: "experiment"
  })
], ExperimentComponent);

export default ExperimentComponent;
